// extracted by mini-css-extract-plugin
export var animationContainer = "_oc-0";
export var footer = "_oc-1";
export var gray = "_oc-2";
export var lineItem = "_oc-3";
export var lineItemImage = "_oc-4";
export var lineItemInfo = "_oc-5";
export var lineItemText = "_oc-6";
export var lineItems = "_oc-7";
export var modalContent = "_oc-8";
export var options = "_oc-9";
export var orderName = "_oc-a";
export var refundAmount = "_oc-b";